const { createSlice } = require('@reduxjs/toolkit');
const mainCollectionPageSlice = createSlice({
    name: "mainCollectionPage",
    initialState: {
        mainCollectionPageNo: 1
    },
    reducers: {
        setmainCollectionPage(state, action) {
            // Update the state directly
            state.mainCollectionPageNo = action.payload;
        }
    },
});
export const { setmainCollectionPage } = mainCollectionPageSlice.actions;
export default mainCollectionPageSlice.reducer;